import type { FC } from "react";
import { Button } from "@mantine/core";
import type { OrderPageState } from "./useOrderPage";

type OrderPageActionsProps = {
  state: OrderPageState;
};

// V1 action buttons only: the parent page owns the layout.
export const OrderPageActions: FC<OrderPageActionsProps> = ({ state }) => {
  const { order, permissions, modals, requests, actions } = state;
  const { activePickupId, latestPickupFile } = state.pickup;

  if (!order) {
    return null;
  }

  return (
    <>
      {permissions.canDownloadDeliveryProof && (
        <Button
          variant="filled"
          onClick={() => actions.downloadDeliveryProof(order.orderReference)}
        >
          Télécharger la preuve de livraison
        </Button>
      )}
      <Button variant="filled" onClick={modals.files.open}>
        Fichiers
      </Button>
      {permissions.canComment && (
        <Button variant="outline" onClick={actions.openHelpRequest}>
          Commentaire
        </Button>
      )}
      {permissions.canRequestRedo && (
        <Button variant="outline" onClick={requests.redo.open}>
          Refabrication
        </Button>
      )}
      {activePickupId && (
        <Button
          variant="outline"
          onClick={() => actions.abortPickup(activePickupId)}
        >
          Annuler le ramassage
        </Button>
      )}
      {activePickupId && latestPickupFile && (
        <Button
          variant="outline"
          onClick={() => actions.downloadFile(latestPickupFile)}
        >
          Télécharger l’étiquette de ramassage
        </Button>
      )}
      {permissions.canRequestPickup && (
        <Button variant="outline" onClick={modals.pickup.open}>
          Demander un ramassage
        </Button>
      )}
    </>
  );
};
